<div class="kl-loading-skeleton" role="status" aria-live="polite">
  @if (announceSr()) {
    <span class="kl-loading-skeleton__sr">{{ announceKey() || 'loading' | translate }}…</span>
  }
  @if (variant() === 'table') {
    <div class="kl-loading-skeleton__table">
      <div class="kl-loading-skeleton__header">
        @for (c of colIndexes(); track c) {
          <p-skeleton height="1rem" [width]="colWidth(c)" borderRadius="4px" />
        }
      </div>
      @for (r of rowIndexes(); track r) {
        <div class="kl-loading-skeleton__row">
          @for (c of colIndexes(); track c) {
            <p-skeleton height="1.125rem" [width]="cellWidth(c)" borderRadius="4px" />
          }
        </div>
      }
    </div>
  } @else if (variant() === 'compact') {
    <div class="kl-loading-skeleton__compact">
      @for (i of compactIndexes(); track i) {
        <p-skeleton
          class="kl-loading-skeleton__compact-line"
          height="0.75rem"
          [width]="compactWidth(i)"
          borderRadius="4px" />
      }
    </div>
  } @else {
    <div class="kl-loading-skeleton__stack">
      @for (i of lineIndexes(); track i) {
        <p-skeleton
          class="kl-loading-skeleton__stack-line"
          height="0.875rem"
          [width]="stackLineWidth(i)"
          borderRadius="4px" />
      }
    </div>
  }
</div>
